import { render, staticRenderFns } from "./platform_points_account_list.vue?vue&type=template&id=e2f04a5c&scoped=true"
import script from "./platform_points_account_list.vue?vue&type=script&lang=js"
export * from "./platform_points_account_list.vue?vue&type=script&lang=js"
import style0 from "./platform_points_account_list.vue?vue&type=style&index=0&id=e2f04a5c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f04a5c",
  null
  
)

export default component.exports